import { render, staticRenderFns } from "./EnergyDistributionDetailedReport.vue?vue&type=template&id=274c6baa"
import script from "./EnergyDistributionDetailedReport.vue?vue&type=script&lang=js"
export * from "./EnergyDistributionDetailedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports